import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import { NavLink } from "react-router-dom";
// import Meta from "../../../Components/Meta.jsx";
import Logo from "../../../Assets/Red_Theme/logo.svg";

function NavigationBar() {
  let menuData = [
    {
      mId: 1,
      menu: "Home",
      to: "/",
    },
    {
      mId: 2,
      menu: "About",
      to: "/about",
    },
    {
      mId: 3,
      menu: "Services",
      to: "/services",
      submenu: [
        {
          menu: "Uiux Designs",
          to: "/uiux-designs"
        },
        {
          menu: "App Development",
          to: "/application-development"
        },
        {
          menu: "Software Development",
          to: "/software-development"
        },
        {
          menu: "Artificial Intelligence",
          to: "/ai-artificial-intelligence"
        },
      ]
    },
    {
      mId: 4,
      menu: "Portfolio",
      to: "/portfolio",
    },
    {
      mId: 5,
      menu: "Blog",
      to: "/blog",
    },
    {
      mId: 6,
      menu: "Career",
      to: "/career",
    },
  ];
  const [verified, setVerified] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (verified) {
      const toRef = setTimeout(() => {
        setVerified(false);
        inputRef.current.value = "";
        clearTimeout(toRef);
      }, 30000);
    }
  }, [verified]);

  return (
    <nav className="navbar navbar-expand-lg">
      {/* <Meta /> */}
      <div className="container">
        <NavLink className="navbar-brand m-0 p-0" to="/">
          <img
            src={Logo}
            //   width={localStorage.getItem("windowWidth") < 500 ? "80" : "100"}
            //   height={localStorage.getItem("windowWidth") < 500 ? "57" : "71"}
            alt="Vidhan Infotech Pvt. Ltd. Blue Logo"
            title="Vidhan Infotech Pvt. Ltd. Blue Logo"
          />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo03"
          aria-controls="navbarTogglerDemo03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse justify-content-end`} id="navbarTogglerDemo03">
          <ul className="nav navbar-nav">
            {menuData.map((menuitem, i) => (
              <li className="nav-link" key={i}>
                <NavLink
                  to={menuitem.to}
                  id={menuitem.mId}
                  className={({ isActive }) => (isActive ? "active" : "")}
                  aria-current="page"
                >
                  {menuitem.menu}
                </NavLink>
                {menuitem.submenu && (
                  <div className="submenu">
                    <ul>
                      {menuitem.submenu.map((sublink, j) => (
                        <li key={j}>
                          <NavLink to={sublink.to} className="innerMenuLink">
                            {sublink.menu}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default React.memo(NavigationBar);
